import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

// Import services
import services from 'services/services';

const useImage = ({
	customId,
	id,
	fetchResourcesAction,
	storePathSelector,
	collectionType,
	isDarkBackground
}) => {
	const { t } = useTranslation();
	const collectionTypes = useSelector(
		({ dictionary }) => dictionary.assetsCollectionTypes
	);

	const { data: files, isLoaded, error } = useSelector(
		(state) => state[storePathSelector].files[collectionType]
	);

	// Get id from url or set custom id
	const productId = customId ? customId : id;

	const handlefetchResources = () => fetchResourcesAction(productId);

	const handleAssetRemove = async ({ assetId }) => {
		try {
			assetId && (await services.delete(`/assets/${assetId}`));
			message.success(t('common:upload_pictures.remove_success'));
			handlefetchResources();
		} catch (error) {
			message.error(t('common:upload_pictures.remove_error'));
		}
	};

	useEffect(() => {
		handlefetchResources();
		// eslint-disable-next-line
	}, []);

	const hasImage = files?.length > 0;

	const conditionalClassName = isDarkBackground ? 'dark-background-logo' : '';

	const collectionId = Object.keys(collectionTypes).find(
		(key) => collectionTypes[key] === collectionType
	);

	return {
		productId,
		files,
		isLoaded,
		error,
		hasImage,
		conditionalClassName,
		collectionId,
		fetchResources: handlefetchResources,
		assetRemove: handleAssetRemove
	};
};

export default useImage;
